import {
  __INTERNAL_DEVTOOLS_HIDE__,
  __INTERNAL_DEVTOOLS_SHOW__,
  __INTERNAL_DIALOG_HIDE__,
  __INTERNAL_DIALOG_SHOW__
} from '../actions/actionTypes';
import initialState from './initialState';

// handles dialog show and hide
export default (state = initialState, action) => {
  switch (action.type) {
    case __INTERNAL_DEVTOOLS_SHOW__:
      return {
        ...state,
        devtools: true
      };
    case __INTERNAL_DEVTOOLS_HIDE__:
      return {
        ...state,
        devtools: false
      };
    case __INTERNAL_DIALOG_SHOW__:
      return {
        ...state,
        show: true,
        options: action.options
      };
    case __INTERNAL_DIALOG_HIDE__:
      return {
        ...state,
        show: false,
        options: null
      };
    default:
      return state;
  }
};
